<template>
  <div>
    <div style="height:60px" class="hidden-md-and-up"></div>
    <h2>Cursos, Talleres y Capacitaciones</h2>
    <v-flex xs12>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex d-flex xs12 sm6 md6 lg4 v-for="(curso,index) in cursos" :key="index">
            <v-card class="elevation-6">
              <v-toolbar
                color="primary lighten-4 font-weight-bold"
                dark
                :height="50"
              >{{curso.titulo}}</v-toolbar>
              <v-img :src="getFileUrl(curso.foto)" aspect-ratio="2"></v-img>
              <v-card-text>
                <h2
                  class="title mb-0"
                  style="font-style:italic; font-size:1rem !important;"
                >"{{curso.tema}}"</h2>
               <v-expansion-panel>
                <v-expansion-panel-content>
                  <div slot="header">Más Información del Evento</div>
                  <v-card class="elevation-0">
                    <v-list subheader>
                      <v-subheader>EXPOSITOR(ES)</v-subheader>

                      <v-list-tile
                        v-for="(exp,index) in getExpositores(curso.expositores)"
                        :key="index"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title>{{ exp.nombre }}</v-list-tile-title>
                          <v-list-tile-sub-title class="caption">{{ exp.cargo }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-subheader>LUGAR EVENTO</v-subheader>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ curso.lugarEvento }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-subheader>FECHA</v-subheader>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>{{formatDate(curso.fechaEvento)}} de {{curso.horaInicio}} a {{curso.horaFin}}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-card-text>             
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  v-if="validarTiempo(curso.fechaEvento,curso.horaInicio)"
                  @click.native="registrarCurso()"
                >Registrarme con Ciudadnia Digital</v-btn>
                <v-btn color="error" small v-else>Vencio</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <section class="pb-3">
      <h2>Biblioteca Virtual</h2>
      <v-layout row wrap>
        <!--
        <v-flex lg12  md12 xs12>
          <v-text-field
            name="name"
            label="Buscar Libro"
            id="id"
            box
            outline
            prepend-icon="search"
          ></v-text-field>
        </v-flex>
        -->
        <v-flex lg2 md3 xs6 v-for="(libro,index) in libros" :key="index">
           <v-hover>
          <v-card  slot-scope="{ hover }">
            <v-img
          :src="getFileUrl(libro.rutaImagenPortada)"
          height="250px"
        >
         <v-expand-transition>
          <div
            v-if="hover"
            class="d-flex transition-fast-in-fast-in primary lighten-5 v-card--reveal white--text"
            style="height: 100%;"
          >
            <v-btn color="red" dark small :href="getFileUrl(libro.rutaArchivoPdf)" target="_blank">Descargar</v-btn>
          </div>
        </v-expand-transition>
        </v-img>
          </v-card>
           </v-hover>
        </v-flex>
      </v-layout>
      <v-pagination v-if="cantidadTotalLibros>12"
      v-model="pagina"
      :length="pages"
    ></v-pagination>
      </section>
    </v-flex>
  </div>
</template>
<script>
export default {
  data() {
    return {
      libros:[],
      cantidadTotalLibros:0,
      pagina:1
    };
  },
  mounted: function() {
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(0);
    }
    this.getLibros()
  },
  computed: {
    url() {
      return this.$docUrl;
    },
    cursos() {
      return this.$store.state.cursos;
    },
     pages () {
        if (this.cantidadTotalLibros == null
        ) return 0

        return Math.ceil(this.cantidadTotalLibros/ 12)
      }
  },
  methods: {
    registrarCurso() {
      window.location.replace("https://sra.justicia.gob.bo/abogado/#/cursos");
    },
    getExpositores(data) {
      return JSON.parse(data);
    },
    validarTiempo(date, hora) {
      var hoy = new Date();
      const [dates, hours] = date.split(" ");
      var fechaFormulario = new Date(dates + " " + hora);
      if (hoy <= fechaFormulario) {
        return true;
      } else {
        return false;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [dates, hours] = date.split(" ");
      if (date.indexOf("-") > 0) {
        const [year, month, day] = dates.split("-");
        return `${day}/${month}/${year}`;
      }
      return date;
    },
    getLibros(){
      this.$http.get(`${this.$apiUrl}publico/libros`).then(response=>{
        this.libros=response.data.data.items
        this.cantidadTotalLibros=response.data.data.total_count
      }).catch(error=>{console.log(error);})
    },
    getFileUrl(url){
      return this.$docUrl+'/'+url;
    }
  }
};
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .7;
  position: absolute;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Capacitacion/Capacitacion.vue